import { IQService, IPromise, IDeferred, IRootScopeService } from "angular";
import { IListChartSettings as IListChartSettings, ListChartSettings } from "..";

export class ChartSettingsLoader {
  private deferred: IDeferred<IListChartSettings>;
  chartSettings: IListChartSettings;
  private isLoaderPromiseResolved = false;

  public static $inject = ["$q", "$rootScope"];

  constructor(private $q: IQService, private $rootScope: IRootScopeService) {}

  init(): void {
    // TODO: try to make this event not promise
    this.deferred = this.$q.defer<IListChartSettings>();
    this.isLoaderPromiseResolved = false;
  }

  promise(): IPromise<IListChartSettings> {
    return this.deferred.promise;
  }

  resolve(args: IListChartSettings): void {
    this.chartSettings = args;
    this.deferred.resolve(args);
    this.isLoaderPromiseResolved = true;
  }

  chartSettingsChange(settings: IListChartSettings, changedFrom: string): void {
    if (this.isResolved) {
      this.chartSettings = settings;
      this.$rootScope.$broadcast("chartSettingsChange", changedFrom);
    }
  }

  formatChartSettingsForSave(): ListChartSettings {
    const { chartCategory, chartValue, aggregation } = this.chartSettings;
    return {
      chartCategory: chartCategory.fieldName,
      chartValue: chartValue.fieldName,
      aggregation: aggregation,
    };
  }
  get isResolved(): boolean {
    return this.isLoaderPromiseResolved;
  }
}
